"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _index = require("@/api/virtualSimulationClass/index");
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: {
    num: Number
  },
  data: function data() {
    return {
      navList: [{
        specialClassName: '社区教育',
        url: '/communityEducation'
      }, {
        specialClassName: '老龄教育',
        url: '/oldAgeEducation'
      }, {
        specialClassName: '终身学习',
        url: '/learning'
      }, {
        specialClassName: '工程师学院',
        url: '/collegeEngineers'
      }]
    };
  },
  created: function created() {
    this.getNav();
  },
  methods: {
    toSecond: function toSecond(url) {
      if (url) {
        this.$router.push(url);
      }
      //  else {
      //   this.$notify.info({
      //     title: "提示",
      //     message: "该功能正在建设中",
      //   });
      // }
    },
    getNav: function () {
      var _getNav = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return (0, _index.specialClassificationList)();
            case 1:
              res = _context.sent;
              this.navList = res.rows;
              this.$forceUpdate();
              this.$emit('specialClass', this.navList);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getNav() {
        return _getNav.apply(this, arguments);
      }
      return getNav;
    }()
  }
};